import React from "react";
const ErrorMsg = ({ msg , className="error"}) => <span className={className}>{msg}</span>;

export default ErrorMsg;
